import { ticketErrorComponent } from './ticketError.component';

export const ticketErrorStateName = 'app.ticketError';

export const ticketErrorState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: ticketErrorStateName,
    url: '/tickets/:ticketId/error',
    params: {
      ticketError: null, // optional
      referral: null // optional
    },
    component: ticketErrorComponent.name,
    data: { requiresAuth: true }
  });
};
